import { styled, IconButton } from '@mui/material';

export const StyledIconButton = styled(IconButton)(({ theme }) => ({
  padding: theme.spacing(0.75),
}));
